// extracted by mini-css-extract-plugin
export default {"root":"z4pgo7","item":"dfP7Uf","title":"VNC101","icon":"biZ9Ix","description":"KX5k8A","example":"fbi9_F","button":"gyoNQY"};